<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="Clases">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />

        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">
          {{ title }}
          <v-btn @click="getall()" dark depressed color="success" v-if="!show_alls">Ver todas</v-btn>
          <v-btn @click="getOnlyFavs()" dark depressed color="info" v-if="show_alls">Ver solo favoritas</v-btn>
        </div>

        <div>
          <br />
          <h2>Mis Cátedras</h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Materia</th>
                  <th>Alumnos</th>
                  <th class="text-left">
                    Favoritas
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(clase, index) in clases" :key="index">
                  <td v-if="show_alls || (!show_alls && clase.visible == true)">{{ clase.id }}</td>
                  <td v-if="show_alls || (!show_alls && clase.visible == true)">{{ clase.materia }}</td>
                  <!-- <td v-if="show_alls || (!show_alls && clase.visible == true)">{{ clase.cantidadAlumno }}</td> -->
                  <td v-if="show_alls || (!show_alls && clase.visible == true)">
                    <v-btn @click="listaAlumnos(clase.id)" small class="
                        info--text
                        text-decoration-underline
                        font-weight-regular
                      " depressed text color="info">Ver</v-btn>
                  </td>
                  <td v-if="show_alls || (!show_alls && clase.visible == true)">
                    <div v-frag>
                      <v-btn v-if="clase.visible == 1" @click="setVisible(clase.id, 0)" title="Ocultar" depressed text
                        color="Colorsuccess">
                        <v-icon dark>mdi-star</v-icon>
                      </v-btn>
                      <v-btn v-else @click="setVisible(clase.id, 1)" title="Mostrar" depressed text
                        color="Colorsuccess">
                        <v-icon dark>mdi-star-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div>
          <br />
          <h2>Alumnos</h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">DNI</th>
                  <th class="text-left">Alumno</th>
                  <th class="text-left">Cant. Clases Visualizadas</th>
                  <th class="text-left">Porcentaje</th>
                  <th class="text-left">Ultimo Acceso</th>
                  <th class="text-left">Notas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(alumno, index) in alumnos" :key="index">
                  <td>
                    {{ alumno.DNI != null ? alumno.DNI : "" }}
                  </td>
                  <td>
                    {{ alumno.fullname }}
                  </td>
                  <td v-if="alumno.materiaLog">
                    {{ alumno.materiaLog.posicionClase + 1 }}
                  </td>
                  <td v-else></td>
                  <td v-if="alumno.materiaLog">
                    {{ ((alumno.materiaLog.posicionClase + 1) / alumno.materiaLog.totalClases) * 100 }}%
                  </td>
                  <td v-else></td>
                  <td v-if="alumno.materiaLog">
                    {{ alumno.materiaLog.ultimoAcceso }}
                  </td>
                  <td v-else></td>
                  <td>
                    <v-btn @click.native="
                      traerNotas(alumno.id_alumno, alumno.cod_catedra)
                      " small class="
                        info--text
                        text-decoration-underline
                        font-weight-regular
                      " depressed text color="info">
                      Ver</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>

      <v-row justify="center">
        <v-dialog v-model="modalNotas" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Notas</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="parcial1" label="Parcial 1" disabled></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="parcial2" label="Parcial 2" disabled></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="final" label="Final" disabled ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modalNotas = false">
                Close
              </v-btn>
              <!-- <v-btn color="blue darken-1" text @click="guardarNotas()">
                Guardar
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Clases",
  components: {
    CardIeaAppMain
  },
  data() {
    return {
      title: "Cátedras",
      clases: [],
      user: [],
      alumnos: [],
      modalNotas: false,
      parcial1: null,
      parcial2: null,
      final: null,
      alumno: null,
      materia: null,
      show_alls: null
    };
  },
  mounted() {
    this.user = this.$store.getters.user;
    this.allClases();

  },
  methods: {

    allClases() {
      this.$API
        .get({
          url: "profesor-clases-v2"
        })
        .then(res => {
          console.log(res.data);
          this.clases = res.data;
        });
    },
    listaAlumnos(materia) {
      this.$API
        .get({
          url: "profesor/lista-alumnos-v6/" + materia
        })
        .then(res => {
          // debugger;
          this.alumnos = res.data;
        });
    },
    traerNotas(alumno, materia) {
      this.alumno = alumno;
      this.materia = materia;

      this.$API
        .post({
          url: "profesor/notas/alumno-v3",
          data: {
            alumno: alumno,
            materia: materia
          }
        })
        .then(res => {
          const parcial1 = res.nota1;
          const parcial2 = res.nota2;
          const final = res.nota3;

          this.parcial1 = parcial1 ? parcial1.nota : null;
          this.parcial2 = parcial2 ? parcial2.nota : null;
          this.final = final ? final.nota : null;
          this.modalNotas = true;
        });
    },

    guardarNotas() {
      this.$API
        .post({
          url: "profesor/notas/alumno/guardar",
          data: {
            alumno: this.alumno,
            materia: this.materia,
            user_id: this.user.IDStB,
            parcial1: {
              tipo: 1,
              nota: this.parcial1,
              status: this.parcial1 == null ? false : true
            },
            parcial2: {
              tipo: 2,
              nota: this.parcial2,
              status: this.parcial2 == null ? false : true
            },
            final: {
              tipo: 3,
              nota: this.final,
              status: this.final == null ? false : true
            }
          }
        })
        .then(() => {
          this.modalNotas = false;
        });
    },


    async setVisible(id, status) {
      // this.materias = null;
      await this.$API
        .post({
          url: "profesor-clases/setvisible",
          data: {
            id: id,
            visible: status
          }
        })
        .then(() => {
          this.allClases();
        });
    },
    getall() {
      this.show_alls = true;
    },
    getOnlyFavs() {
      this.show_alls = false;
    },
  }
};
</script>
